import DromoUploader from 'dromo-uploader-react'
import * as React from 'react'
import { useData, useHandlers } from './hooks'
import { ImportsPage } from './ImportsPage/ImportsPage'
import Typography from '@mui/material/Typography'
import { MessageDialogPopup } from '@sales-center/components'

export function ImportUtility() {
  const uploaderProps = useData()

  const { onResults, onCancelDromo, cancelClick, onDrawerSave } = useHandlers({
    ...uploaderProps,
  })
  const { uploadId, showDromo, user, showConfirmPopup } = uploaderProps

  return (
    <div>
      {showDromo ? (
        <DromoUploader
          {...uploaderProps}
          open={uploadId === null}
          onResults={onResults}
          onCancel={onCancelDromo}
        ></DromoUploader>
      ) : (
        <ImportsPage onDrawerSave={onDrawerSave} />
      )}

      <MessageDialogPopup
        open={showConfirmPopup}
        title="Data Import is in progress!"
        message="The processing time will depend on the number of records in your file."
        cancelButtonText="Close"
        cancelClick={cancelClick}
      >
        <Typography variant="body1" fontSize={16}>
          We will send an email notification to
          <Typography variant="subtitle3" component="span" marginX="3px">
            {user?.email}
          </Typography>
          once it is completed.
        </Typography>
      </MessageDialogPopup>
    </div>
  )
}
